
import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRouteSnapshot, CanDeactivateFn, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { CancelingProcessesModalComponent } from '../components/canceling-processes-modal/canceling-processes-modal.component';
import { ConfirmCancelProccessService } from '../services/confirm-cancel-proccess.service';

type CanDeactivateType = Observable<boolean> | Promise<boolean> | boolean;

export interface CanComponentDeactivate {
  canDeactivate: () => CanDeactivateType;
}

export const cancelingProcessesGuard: CanDeactivateFn<any> = (component) => {
  const dialog = inject(MatDialog);
  const activateGuardService = inject(ConfirmCancelProccessService);
  const status = activateGuardService.status;
  console.log(status());

  if (status()) {
    const dialogRef = dialog.open(CancelingProcessesModalComponent, {
      width: '400px',
      data: {
        title: $localize`Unsaved changes`,
        message: $localize`You have unsaved changes. Are you sure you want to continue?`
      },
    });

    return dialogRef.afterClosed();
  }

  return true;
};
